export enum TransactionLoaderKey {
  GET_TRANSACTION = 'transaction-get',
  GET_TRANSACTION_METRICS = 'transaction-metrics',
  GET_RECENT_TRANSACTION = 'transaction-recent',
  LIST_TRANSACTION = 'transaction-list',
  GET_TRANSACTION_PREVIEW = 'transaction-preview',
  UPLOAD_TRANSACTION = 'transaction-upload',
}
